<template>
    <div class="news_column_title" v-animate="'fade-in'">
        <ul class="news_list d-flex fw-bold">
            <li :class="`${country}`" v-html="`${country}`"></li>
        </ul>
        <h2 class="news_title" v-html="title"></h2>
        <!--<div class="works_column d-flex align-items-center">
            <p class="works_column_text fw-bold mb-0">Share This On</p>
            <div class="sns d-flex">
                <div class="sns_icon">
                    <a href="#" class="sns_icon_anchor">Facebook</a>
                </div>
                <div class="sns_icon">
                    <a href="#" class="sns_icon_anchor">Twitter</a>
                </div>
            </div>
        </div>-->
    </div>
</template>

<script>
    export default {
        name: 'NewsTitle',
        props: {
            title: String,
            country: Array,
        }
    }
</script>

<style lang="scss" scoped>
    .news_column_title {
        position: fixed;
        width:inherit;
    }

    .news_title {
        font-size: 38px;
        line-height: 1.6;
        margin-bottom: 59px;
        width: 60%;
    }

    .sns {
        margin-left: 20px;

        &_icon {
            width: 40px;
            height: 40px;
            text-indent: -9999px;

            &:first-child {
                margin-right: 15px;

                .sns_icon_anchor:after {
                    background: url(../../assets/works/facebook.svg) no-repeat center center;
                    background-size: cover;
                    transition: all 0.3s;
                }

                .sns_icon_anchor:hover:after {
                    background: url(../../assets/works/facebook_blue.svg) no-repeat center center;
                    background-size: cover;
                }
            }

            &:last-child {
                .sns_icon_anchor:after {
                    background: url(../../assets/works/twitter.svg) no-repeat center center;
                    background-size: cover;
                    transition: all 0.3s;
                }

                .sns_icon_anchor:hover:after {
                    background: url(../../assets/works/twitter_blue.svg) no-repeat center center;
                    background-size: cover;
                }
            }

            &_anchor {
                display: block;
                position: relative;

                &:after {
                    content: '';
                    display: block;
                    width: 40px;
                    height: 40px;
                    position: absolute;
                    left: 0;
                    top: 0;
                }
            }
        }
    }

    @media screen and (max-width: 991px) {
        .news_column_title {
            max-width: 35vw;
        }
        
        .news_title {
            width: 100%;
        }
    }

    @media screen and (max-width: 767px) {
        .news_column_title {
            position: relative;
            width: 100%;
            max-width: unset;
        }
    }
</style>
